import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import EbookDownload from "./pages/EbookDownload";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title>Download 5 Truths About The School To Prison Pipeline</title>
          <meta 
            name="description" 
            content="Download the free ebook exposing how school discipline policies push Black students from classrooms into the criminal justice system." 
          />
          <meta name="author" content="Rahiem Shabazz" />
          <meta property="og:title" content="Download 5 Truths About The School To Prison Pipeline" />
          <meta property="og:description" content="Download the free ebook exposing how school discipline policies push Black students from classrooms into the criminal justice system." />
          <meta property="og:type" content="website" />
        </Helmet>
        <BrowserRouter>
          <Routes>
            <Route path="/E-Book-Download" element={<EbookDownload />} />
            <Route path="/" element={<Navigate to="/E-Book-Download" replace />} />
            <Route path="*" element={<Navigate to="/E-Book-Download" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
